import { useClientMounted } from '@/common/hooks/useClientMounted';
import { isMobileViewport } from '@/common/hooks/useResponsive';
import { isDoctorDeviceCached } from '@/common/utils/doctorDeviceCache';
import { isDoctorHomeRedirectPath } from '@/common/utils/doctorHomePaths';
import { isPatientViewModeStored } from '@/modules/doctorHome/store/viewMode';
import { useSpaPatientViewStore } from '@/modules/doctorHome/utils/spaPatientView';
import { useUserInfoStore } from '@/modules/login/store/userInfo';
import { useRouter } from 'next/router';
import { hasDoctorIdentity } from '@/common/utils/doctorIdentity';

export const useDoctorHomeRedirectLoading = () => {
  const router = useRouter();
  const mounted = useClientMounted();
  const pending = useUserInfoStore(state => state.pending);
  const doctorProfilePending = useUserInfoStore(state => state.doctorProfilePending);
  const userInfo = useUserInfoStore(state => state.info);
  const spaPatientView = useSpaPatientViewStore(state => state.active);
  const isCachedDoctor = mounted && isDoctorDeviceCached();

  const onRedirectPath = isDoctorHomeRedirectPath(router.pathname);
  const isPatientOptOut = spaPatientView || (mounted && isPatientViewModeStored());

  // Desktop never. Patient SPA switch never shows redirect loading.
  if (!mounted || !onRedirectPath || !isMobileViewport() || isPatientOptOut) return false;

  const isDoctor = hasDoctorIdentity(userInfo, isCachedDoctor);

  // Cached doctors: show loading while auth/profile settles before hard redirect.
  if ((pending || doctorProfilePending) && isCachedDoctor) return true;

  // Confirmed doctors ready to redirect — keep shell loading (avoid patient home flash).
  return !pending && !doctorProfilePending && isDoctor;
};
